import { cn } from '@/lib/utils';
import { getJournalCardBackgroundUrl } from '@emovia/design-system';
import { cva } from 'class-variance-authority';

export type SelectedCardProps = {
  text: string;
  category: string;
  style?: React.CSSProperties;
  size?: 'small' | 'large';
  disabled?: boolean;
  selected?: boolean;
  className?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const cardVariants = cva(
  'flex flex-col justify-between rounded-[26px] border bg-card bg-cover bg-center p-2 shadow-lg origin-bottom text-left transition-all duration-200 ease-out focus:outline-none',
  {
    variants: {
      size: {
        small: 'h-52 w-40',
        large: 'h-64 w-44',
      },
    },
    defaultVariants: {
      size: 'large',
    },
  },
);

const SelectedCard = ({
  text,
  category,
  style,
  size,
  disabled,
  selected,
  className,
  onClick,
  onMouseEnter,
  onMouseLeave,
}: SelectedCardProps) => {
  const variant = cardVariants({ size });
  const backgroundUrl = getJournalCardBackgroundUrl(category);
  const styleWithBackground = {
    ...style,
    backgroundImage: `url(${backgroundUrl})`,
  };

  return (
    <button
      className={cn(variant, selected && 'border-primary shadow-primary/50 ring-1 ring-primary/50', className)}
      style={styleWithBackground}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={disabled}
    >
      <div className="flex h-full flex-col justify-between gap-4 pt-4">
        <div className="flex items-center justify-between gap-2 text-[11px] uppercase tracking-[0.18em] text-slate-600 px-2">
          <span>{category}</span>
        </div>
        <p className="flex-1 line-clamp-6 text-sm font-medium leading-relaxed text-slate-900 p-2 bg-white/60 rounded-xl">
          {text}
        </p>
      </div>
    </button>
  );
};

export default SelectedCard;
